import React from 'react';
import PropTypes from 'prop-types';
import { H3 } from 'shared-assets/components/Elements';
import { Col, Row } from 'react-styled-flexboxgrid';
import Card from 'shared-assets/components/Card';
import { Tooltip } from 'react-tippy';
import { DetailsTable } from 'shared-assets/components/Table';
import colors from 'shared-assets/lib/colors';
import {
  AttentionFilledIcon,
  Box,
  PlusOutlinedIcon,
  ThemeProvider,
  Typography,
} from '@kareo/design-system';
import Banner from 'shared-assets/components/Banner';
import AccessLink from 'shared-assets/facesheet-ui/components/ProtectedPatientChart/ChartAccess/AccessLink';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';

export const PatientInfoWidget = props => {
  const dsTheme = getDesignSystemTheme();
  return (
    <ThemeProvider theme={dsTheme}>
      <React.Fragment>
        <Box mb="8px" lineHeight="18px">
          <H3>
            {props.firstName} {props.lastName}
          </H3>
          <If
            condition={
              props.userChartAccess?.clinicalDataAccessRestrictionEnabled ||
              props.userChartAccess?.chartAccessRestrictionEnabled
            }
          >
            <AccessLink
              linkLabel={
                props.userChartAccess.patientRestricted
                  ? 'Restricted'
                  : 'Unrestricted'
              }
              patientId={props.patientId}
              firstName={props.firstName}
              lastName={props.lastName}
              protectionSettings={props.protectionSettings}
              userChartAccess={props.userChartAccess}
              togglePatientRestriction={props.togglePatientRestriction}
              style={{ color: colors.primary }}
            />
          </If>
        </Box>
        <Row>
          <Col xs={8} style={{ paddingRight: '.25rem' }}>
            <img
              style={{
                height: '105px',
                marginBottom: 0,
                boxShadow: '0 1px 2px rgb(0 0 0 / 10%)',
              }}
              src={props.patientPhotoUrl}
              onError={e => {
                e.target.onerror = null;
                e.target.src = 'img/empty-profile-m.png';
              }}
            />
          </Col>
          <Col className="patient-summary" xs={4} style={{ paddingLeft: 0 }}>
            <Card
              className="patient-controls card wire"
              style={{
                height: '105px',
                marginBottom: 0,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Tooltip
                position="right-start"
                theme="light"
                arrow
                html={
                  <Box>
                    <Typography variant="body1" component="div" align="left">
                      Patient Details
                    </Typography>
                    <DetailsTable style={{ width: '13rem', margin: '.5rem 0' }}>
                      <tbody style={{ lineHeight: '.5rem' }}>
                        <Typography
                          variant="body2"
                          component="div"
                          display="inline"
                        >
                          <tr>
                            <th>Gender</th>
                            <td>{props.gender}</td>
                          </tr>
                          <tr>
                            <th>DoB</th>
                            <td>{props.dateOfBirth}</td>
                          </tr>
                          <tr>
                            <th>Balance</th>
                            <td>{props.balance}</td>
                          </tr>
                        </Typography>
                      </tbody>
                    </DetailsTable>
                  </Box>
                }
              >
                <Box pl="2px">
                  <AttentionFilledIcon color="primary" fontSize="small" />
                </Box>
              </Tooltip>
              <Tooltip
                position="right-start"
                theme="light"
                arrow
                html={
                  <Banner
                    style={{ width: '13rem', textAlign: 'left' }}
                    type="info"
                    message="Patient actions, such as printing patient education, creating prescriptions and ordering labs will be coming soon."
                  />
                }
              >
                <PlusOutlinedIcon color="primary" fontSize="small" />
              </Tooltip>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    </ThemeProvider>
  );
};

PatientInfoWidget.propTypes = {
  patientId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  patientPhotoUrl: PropTypes.string,
  gender: PropTypes.string,
  dateOfBirth: PropTypes.string,
  balance: PropTypes.string,
  accessLink: PropTypes.string,
  accessImage: PropTypes.string,
};

PatientInfoWidget.defaultProps = {
  patientId: 0,
  firstName: '',
  lastName: '',
  patientPhotoUrl: 'img/empty-profile-m.png',
  gender: 'Unknown',
  dateOfBirth: '',
  balance: 0,
  accessLink: '',
  accessImage: '',
};
